/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
import { App } from "./App";
export const AppsResponse = core.serialization.object({
    data: core.serialization.list(App),
});
